<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        Create Contact Request
    </div>
    <div class="nova__dialog__toolbar__controls">
        <button class="nova__button--icon" (click)="close()">
            <mat-icon class="nova-toolbar__controls__icon--close">close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content class="nova__dialog__content">
    <form [formGroup]="requestedChangesForm">
        <div class="field-container">
            <span class="label-text">What would you like the AM to change?</span>
            <textarea required rows="6" class="special-request-textarea" formControlName="changeText"></textarea>
        </div>

        <mat-dialog-actions class="nova__dialog__content__actions" align="start">
            <button mat-raised-button color="primary" [disabled]="!requestedChangesForm.valid" (click)="requestChanges()">Request Changes</button>
            <button mat-raised-button color="default" [mat-dialog-close]="false">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>
